var _path, _circle;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAlert(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.841 5.72h1.32V11h-1.32V5.72zm-.187-1.793c0-.213.077-.396.231-.55a.82.82 0 01.605-.242c.242 0 .444.077.605.231a.71.71 0 01.253.561.743.743 0 01-.253.572.865.865 0 01-.605.22.842.842 0 01-.605-.231.788.788 0 01-.23-.561z",
    fill: "#FB4E4E"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.5,
    r: 6.9,
    stroke: "#FB4E4E",
    strokeWidth: 1.2
  })));
}

export default SvgAlert;